// import traitData from "./invalid_traits.json"
import {constructURL,transformData} from './function'
const backendurl = process.env.REACT_APP_EXLIBRIS_SERVICE;
const blupsapi = process.env.REACT_APP_BLUPSAPI;
//const nexusapi = process.env.REACT_APP_NEXUSAPI;





const checkUserPermission = async () => {
  try {
    const response = await fetch(`${backendurl}/allow-access`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    return result
  } catch (error) {
    return false;
  }
};

const getAvailableDatabases=async()=>{
  try{
    const url = `${backendurl}/databases`;
    const response = await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
    });
    if (!response.status===200) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    return result
  }catch(err){
    return { error: true, message: 'Failed to get database options' }
  }
}

const getFilterObjects = async (dbCode) => {
  try {
    const url = `${backendurl}/meta-data/?dbCode=${encodeURIComponent(dbCode)}`
    const response = await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
    });
    if (!response.status===200) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    return result
  }
  catch {
    return {error: true, message: 'Failed to get filter objects'}
  }
};

const getEtlNotification = async () => {
  try {
    const response = await fetch(`${backendurl}/etl-notification/`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    return result
  } catch (error) {
    return false;
  }
};

const sendDataRequest = async (url,filterOptions) => {
  //console.log('Sending Request URL ',url)
  //console.log('Sending Request Body ',filterOptions)
  try {
    const response = await fetch(url, {
      method: "POST",
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
      },
      body:JSON.stringify({data:filterOptions})
    });
    //console.log('Response ',response)
    if (!response.ok) {
      return { error: true, message: `HTTP error! Status: ${response.status}` };
    }

    if (!response.body) {
      throw new Error("No response body");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let streamData = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      streamData += decoder.decode(value, { stream: true });
    }
    try {
      const parsedData = JSON.parse(streamData); // ✅ This will now work correctly
      return {
        error: false,
        message: 'Success',
        isDerived: parsedData.isDerived,
        data: parsedData.data || []
      };
    } catch (error) {
      return { error: true, message: 'Failed to parse response' };
    }
  } catch (error) {
    //console.log('Error in Fetching Data ', error)
    return { error: true, message: "Failed to fetch data" };
  }
};

const getData = async (dbCode, dataType, filterOptions) => {
  

  try {    
    const finalURL = await constructURL(dbCode,dataType);
    const response = await sendDataRequest(finalURL,filterOptions);
    const data = await transformData(response,dataType,dbCode);
    return data
    
  } catch (err) {
    console.log('Error in GetData ',err)
    return { error: true, message: 'An error occurred while trying to fetch data' };
  }
  
};


const sendPostRequest = async (url, body) => {
  const response = await fetch(url, {
    method: "POST",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body)
  });
  const data = await response.json()
  return data
}



export const syncData = async (years, database) => {
  const data = {
    years: years,
    database: database,
  };
  const url = `${backendurl}/sync`;
  const response = (
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
  ).json();
  return response;
};


const runBlupsAnalysis = async (traits, data) => {
  try {
    const body = { traits: traits, data: data };
    const url = `${blupsapi}/blups`;
    const response = await sendPostRequest(url, body);
    return response;
  }
  catch {
    return { error: true, message: 'BLUPs Analysis failed' }
  }
};


const getTraitAverages = async (traits, data) => {
  try {
    const body = { traits: traits, data: data };
    const url = `${blupsapi}/average`;
    const response = await sendPostRequest(url, body);
    if (response.status === 200) {
      return { error: false, message: 'Success', data: response.data }
    }
    else {
      throw new Error('Error')
    }
  }
  catch {
    return { error: true, message: 'Failed to get trait averages' }
  }
};

const getCountByYear = async (traits, data) => {
  try {
    const body = { traits: traits, data: data };
    const url = `${blupsapi}/count-by-year`;
    const response = await sendPostRequest(url, body);
    if (response.status === 200) {
      return { error: false, message: 'Success', data: response.data }
    }
    else {
      throw new Error('Error')
    }
  }
  catch {
    return { error: true, message: 'Failed to get count by year' }
  }
};

const getCountByLocYear = async (traits, data) => {
  try {
    const body = { traits: traits, data: data };
    const url = `${blupsapi}/count-by-loc-year`;
    const response = await sendPostRequest(url, body);
    if (response.status === 200) {
      return { error: false, message: 'Success', data: response.data }
    }
    else {
      throw new Error('Error')
    }
  }
  catch {
    return { error: true, message: 'Failed to get count by loc and year' }
  }
};

export {checkUserPermission, getAvailableDatabases, 
  getFilterObjects, getData, runBlupsAnalysis,getCountByYear,
  getTraitAverages,getCountByLocYear,
  getEtlNotification
}